<template>
    <div>
      <p v-if="$route.params.status == 'success'">Płatność została zrealizowana.</p>
      <p v-else>Płatność nie została zrealizowana.</p>
      <router-link :to="{name: 'runner-payments', params: {id: $route.params.id}}">Powrót do listy płatności</router-link>
    </div>
</template>

<script>
export default {
  created () {
    this.$router.push({name: 'runner-payments', params: {id: this.$route.params.id}, query: {status: this.$route.params.status}})
  }
}
</script>



// WEBPACK FOOTER //
// src/payments/RunnerPaymentReturn.vue